import { useEffect } from "react";

const ZohoSalesIQ = () => {
    useEffect(() => {
        if (window.$zoho) return;
        window.$zoho = window.$zoho || {};
        window.$zoho.salesiq = {
            widgetcode:
                "siq2c68e8f4a6fd515861ec9420d8cc838c077a6edf36a6ddbfef5cf97afcade87f",
            values: {},
            ready: function () { }
        };

        const script = document.createElement("script");
        script.type = "text/javascript";
        script.id = "zsiqscript";
        script.defer = true;
        script.src = "https://salesiq.zoho.in/widget";

        document.body.appendChild(script);

        return () => {
            document.getElementById("zsiqscript")?.remove();
        };
    }, []);

    return null;
};

export default ZohoSalesIQ;
